<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.22 2.47a.75.75 0 011.06 0l3.87 3.868.018.019c.182.182.349.35.477.5.139.163.275.356.355.602.114.352.114.73 0 1.082-.08.246-.216.439-.355.602-.128.15-.295.318-.477.5l-.019.019L6.28 13.53a.75.75 0 01-1.06-1.06L9.088 8.6c.207-.207.33-.33.414-.43a.627.627 0 00.073-.097.25.25 0 000-.148.627.627 0 00-.073-.098 8.343 8.343 0 00-.414-.429L5.22 3.53a.75.75 0 010-1.06z"
    fill="currentColor"
  />
</svg>
